{
  "app_notification_title": "You’ve been invited to provide feedback for the candidate",
  "avg_score": "Avg. score",
  "change_answers": "Edit feedback",
  "completed": "Completed",
  "create_new_motivation_description": "Make interview feedback clear and consistent across the team\nDefine what matters for the role and help everyone focus on what really counts",
  "create_new_motivation_title": "Add your first scorecard",
  "create_scorecard": "Create scorecard",
  "deleted": "Deleted",
  "duplicate_scorecard": "Duplicate scorecard",
  "duplicate_scorecard_confirm": "A draft copy of this scorecard will be created.",
  "error_select_at_least_one_participant": "Please select at least one participant",
  "feedback": "Feedback",
  "feedback_sent": "Feedback on candidate {candidate_name} has been sent",
  "feedbacks": "Feedbacks",
  "has_feedback": "There is feedback available",
  "invitation_resent": "Invitation has been sent",
  "invitations_sent": "Invitations have been sent",
  "manage_forms": "Manage forms",
  "manage_scorecards": "Manage scorecards",
  "notification_settings_feedbacks": "New feedback requests or results",
  "request_feedback": "Request feedback",
  "resend_invite": "Resend invitation",
  "return_to_candidate": "Return to candidate",
  "return_to_candidates": "Return to candidates",
  "scorecard": "Scorecard",
  "scorecards": "Scorecards",
  "search_forms": "Search forms",
  "show_profile": "Show profile of {applicant}",
  "submit_your_response": "Submit your response",
  "view_feedback": "View feedback",
  "~": "~"
}
